/* eslint react-hooks/preserve-manual-memoization: ["warn"] */
import { useMemo } from "react";
import { User } from "@coworker/apprestructured/src/shared/types/user";
import {
  FilterType,
  InputType,
  MultiSelectFilter,
  RowVisibility,
} from "@coworker/apprestructured/src/shared/filters/types/filter";
import { useTranslation } from "react-i18next";
import filterUsersByTeamId from "../../helpers/filterUsersByTeamId";
import rolesTranslations from "../../constants/roleTranslations";

export const ROLE_MULTISELECT_ID = "rolesMultiSelect";

const useRolesMultiSelectFilter = (
  enabled: boolean,
  users: User[],
  showAllUsers: boolean,
  teamId?: string
): MultiSelectFilter => {
  const { t } = useTranslation();

  const defaultValue = {
    filterId: ROLE_MULTISELECT_ID,
    value: [],
  };

  const options = useMemo(() => {
    const filteredUsers = showAllUsers
      ? users
      : filterUsersByTeamId(users, teamId);
    const roles = Array.from(
      new Set(filteredUsers.map((user) => user["roleId"]))
    ).filter(Boolean);
    return roles.map((role) => ({
      value: role,
      title: t(`${rolesTranslations[role]}`),
    }));
  }, [showAllUsers, users, teamId]);

  return {
    inputType: InputType.MultiSelect,
    filterType: FilterType.Filter,
    id: ROLE_MULTISELECT_ID,
    title: t("roleString"),
    options,
    enabled,
    defaultValue,
    showSearch: true,
    noResultsTitle: t("noRolesFoundString"),
    noResultsDescription: t("noRolesFoundDescriptionString"),
    rowVisibility: RowVisibility.PillOnly,
    isFetching: false,
  };
};

export default useRolesMultiSelectFilter;
